import { useTheme } from '@/components/theme/ThemeProvider';
import { useMermaidSvg } from './useMermaidSvg';

interface Props {
  source: string;
}

/**
 * Mermaid 다이어그램 렌더 (우측 아티팩트 패널 전용). 테마(다크/라이트)에 맞춰 렌더하고 자연
 * 크기로 표시(가독성). source 가 잘못된 mermaid 문법이면 에러 메시지를 표시.
 * 패널 자체 전체화면(ArtifactPanel)이 있어 별도 확대 모달은 두지 않는다.
 */
export function MermaidArtifact({ source }: Props) {
  const { resolved } = useTheme();
  const { svg, error, cleaned } = useMermaidSvg(source, { dark: resolved === 'dark' });

  if (error) {
    return (
      <div className="flex h-full flex-col gap-2 p-4">
        <div className="rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive">
          mermaid 렌더 에러: {error}
        </div>
        <pre className="flex-1 overflow-auto rounded-md bg-code-bg p-3 font-mono text-xs text-foreground/90 whitespace-pre-wrap">
          {cleaned}
        </pre>
      </div>
    );
  }

  if (!svg) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-foreground-muted">
        mermaid 렌더링 중…
      </div>
    );
  }

  return (
    <div
      className="flex h-full w-full items-start justify-center overflow-auto bg-surface p-4 [&_svg]:h-auto [&_svg]:max-w-none"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: mermaid.render 가 생성한 SVG.
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
